import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import dmAuth from '../packages/dmAuth/DmAuth.js'
import dmMessages from '../packages/dmMessages/DmMessages.js'
import VuexPersistence from 'vuex-persist'



Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

axios.interceptors.request.use(
    function(config) {
        config.headers = {Authorization: "Bearer " + Vue.dmAuth.getToken()};
        return config
    }, (error) => {
          console.log('request failed')
        return Promise.reject(error)
    }
)

export const store = new Vuex.Store({
    
    state: {
        //domainRE: /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/igm,
        //emailRE: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        //telRE: /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
        messagebar:false,
        apisuccess: {
            message:'',
            action:''
        },
        apierror: {
            message:'',
            action:''
        },
        board: {
          firmen: {
              created: [],
              updated: [],
              total: []
          },
          marken: {
              created: [],
              updated: [],
              total: []
          },
          errors: {
              firmen_marken: [],
              firmen_adressen: [],
              firmen_created: [],
              firmen_updated: [],
              marken_firmen: [],
              marken_types: [],
              marken_warengruppen: [],
              marken_logos: [],
              marken_created: [],
              marken_updated: [],
              marken_dummylogo: [],
          }
        },
        
        showFilterDialog: false,
        preFilteredFirmen: [],
        preFilteredMarken: [],
        authUser: null,
        isAuth: false,        
        search:'',
        firmen:[],
        firma: null,
        marken:[],
        apimarken:[],
        marke:null,        
        adressen:[], 
        adresse: null,
        types:[], 
        ccClients:[],        
        warengruppen:[], 
        loading: false,        
        menuItems:[
            {title:'Login', 
            icon:'lock_open', 
            link:'/login',
            sub:[],
            action:'' ,
            link:'/login'           
            },
            {title:'Register', 
            icon:'face', 
            link:'/register',
            sub:[],
            action:'',
            link:'/register'
            }
        ],            
        
        authMenuItems:[
            {title:'Admin', 
            icon:'group', 
            sub:[
                    {title:'Passport', icon:'local_post_office', link:'/admin/passport'},
                    {title:'Config', icon:'local_post_office', link:'/admin/config/markenapi'},
                    {title:'Import', icon:'local_post_office', link:'/admin/import/import'},
                    
                ], 
            action:'',
            link:''
            },  
            {title:'Listen', 
            icon:'layers',
            sub:[
                {title:'Firmen', icon:'layers', link:'/firmen'},
                {title:'Marken', icon:'layers', link:'/marken'}
                ],
            action:'',
            link:''
            },
            {title:'Create', 
            icon:'directions',
            sub:[
                    {title:'Firmen', icon:'layers', link:'/firmen/create'},
                    {title:'Marken', icon:'layers', link:'/marken/create'},
                    {title:'Adressen', icon:'layers', link:'/adressen/create'}
                ],
            action:'',
            link:''

            },                    
            {title:'Profil', 
            icon:'person', 
            sub:[
                    {title:'Profil', icon:'layers', link:'/profile'}
                ], 
            action:'',
            link:''
            },  
            
        ],                    
        
    },
    mutations: {
        clearMessages: function(state){
            state.apisuccess.message=''
            state.apisuccess.action=''
            state.apierror.message=''
            state.apierror.action=''
            
        },
        setSuccess: function(state,payload) {
           
            state.apisuccess.message=payload.message
            state.apisuccess.action=payload.action
        },
        setError: function(state,payload) {
           
            state.apierror.message=payload.message
            state.apierror.action=payload.action
        },
        setMessagebar: function(state, payload) {
            state.messagebar = payload
        },
        killAuthUser: function(state) {
            
            state.authUser=null
        },
        showFilterDialog: function(state, payload) {
            state.showFilterDialog=payload
        },
        setAuth: function(state) {
            state.isAuth=false;
            
            if (Vue.dmAuth.isAuthenticated()) {   
                            
                state.isAuth = true;            
            }
        },
        setAuthenticatedUser: function(state, payload) {
                               
            if(Vue.dmAuth.isAuthenticated()) {
                state.authUser = payload;                                           
            }
           
        },
        setBoard: function(state, payload) {
            state.board.firmen.total = payload.firmen_total;
            state.board.firmen.created = payload.firmen_sinceLastLogin;
            state.board.firmen.updated = payload.firmen_updatedSinceLastLogin;
            state.board.marken.total = payload.marken_total;
            state.board.marken.created = payload.marken_sinceLastLogin;
            state.board.marken.updated = payload.marken_updatedSinceLastLogin;
            state.board.errors.firmen_marken = payload.firmen_withoutMarke;
            state.board.errors.firmen_adressen = payload.firmen_withoutAdresse;
            state.board.errors.firmen_created = payload.firmen_withoutCreated;
            state.board.errors.firmen_updated = payload.firmen_withoutUpdated;
            state.board.errors.marken_firmen = payload.marken_withoutFirma;
            state.board.errors.marken_types = payload.marken_withoutType;
            state.board.errors.marken_warengruppen = payload.marken_withoutWarengruppe;
            state.board.errors.marken_logos =payload.marken_withoutLogo;
            state.board.errors.marken_created =payload.marken_withoutCreated;
            state.board.errors.marken_updated =payload.marken_withoutUpdated;
            state.board.errors.marken_dummylogo = payload.marken_withDummyLogo;
    
        },
        updateSearch (state, search) {
            state.search = search
        },
        setFirmen(state, payload) {
            state.firmen = payload;
        },
        deleteFirma(state, payload) {
            state.firmen = payload
        },
        setMarken(state, payload) {
            state.marken = payload;
        },
        deleteMarke(state, payload) {
            state.marken = payload
        },
        setAdressen(state, payload) {
            state.adressen = payload;
        },
        deleteAdresse(state, payload) {
            state.adressen = payload
        },
        setMarke(state, payload) {
            
            state.marke = payload;
           
        },
        setFirma(state, payload) {
            
            state.firma = payload;
          
        },
        setAdresse(state, payload) {
            
            state.adresse = payload;
          
        },
        setTypes(state, payload) {
            state.types = payload
        },
        setWarengruppen(state, payload) {
            state.warengruppen = payload
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        //quick and dirty
        setCCClients(state,payload) {
            if(state.authUser.roles[0].name=="Admin") {
                state.ccClients=payload
            } else {
                state.ccClients=payload.filter(function(el){
                    return el.name.match(/wdv/i)
                })
            }
            //console.log(payload)
        },
        
        setPreFilteredFirmen (state, payload) {
            state.preFilteredFirmen = []
            state.preFilteredFirmen = payload
        },
        setPreFilteredMarken (state, payload) {
            state.preFilteredMarken = []
            state.preFilteredMarken = payload
        },
        setApiMarken(state, payload) {
            state.apimarken=payload
        }
        
        
    },
    actions: {
        setApiMarken: function(context) {
            return new Promise(function(resolve, reject) {
                axios.get('api/api/marken')
                    .then((response) => {                      
                        context.commit('setApiMarken', response.data)                   
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            })
        },
        setSuccess: function(context,payload) {
            context.commit('clearMessages')
            context.commit('setSuccess',payload)
        },
        setError: function(context,payload) {            
            context.commit('clearMessages')
            context.commit('setError',payload)
        },
        setPreFilteredFirmen: function(context, payload) {
            context.commit('setPreFilteredFirmen', payload)
        },
        setPreFilteredMarken: function(context, payload) {
            context.commit('setPreFilteredMarken', payload)
        },
        setBoard: function(context) {
            return new Promise(function(resolve, reject) {
                axios.get('api/dashboard')
                    .then((response) => {                      
                        context.commit('setBoard', response.data)                   
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            })
        },
        setMarke: function(context,payload) {
            axios.get('api/marken/' + payload)
                .then((response) => {                      
                    context.commit('setMarke', response.data)                                        
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setFirma: function(context,payload) {
            axios.get('api/firmen/' + payload)
                .then((response) => {  
                    
                    context.commit('setFirma', response.data)         
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setAdresse: function(context,payload) {
            axios.get('api/adressen/' + payload)
                .then((response) => {  
                    
                    context.commit('setAdresse', response.data)         
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteFirma: function(context, payload) {
            axios.delete('api/firmen/' + payload)
                .then((response) => {              
                    context.dispatch('setSuccess', {message:'Löschen erfolgreich', action:'deleteFirma'})
                    context.commit('deleteFirma', response.data)
                   
            })
                .catch((error) => {
                    context.dispatch('setError', {message:'Löschen fehlgeschlagen', action:'deleteFirma'})
                    console.log(error);
            });
            
        },
        deleteMarke: function(context, payload) {
            axios.delete('api/marken/' + payload)
                .then((response) => {                
                    context.dispatch('setSuccess', {message:'Löschen erfolgreich', action:'deleteMarke'})
                    context.commit('deleteMarke', response.data)                    
                   
            })
                .catch((error) => {
                    context.dispatch('setError', {message:'Löschen fehlgeschlagen', action:'deleteMarke'})
                    console.log(error);
            });
            
        },
        deleteAdresse: function(context, payload) {
            axios.delete('api/adressen/' + payload)
                .then((response) => {       
                    context.dispatch('setSuccess', {message:'Löschen erfolgreich', action:'deleteAdresse'})
                    context.commit('deleteAdresse', response.data)                    
                   
            })
                .catch((error) => {
                    context.dispatch('setError', {message:'Löschen fehlgeschlagen', action:'deleteAdresse'})
                    console.log(error);
            });
            
        },
        loginUser: function(context,payload){
            
            var data = new FormData();            
            data.append("email", payload.email);
            data.append("password", payload.pass);
            
            return new Promise((resolve, reject) => {
                axios.post('api/login' , data)
                    .then((response) => {                                  
                        context.dispatch('setSuccess', {message:'Anmeldung erfolgreich', action:'login'})
                        Vue.dmAuth.setToken(response.data.access_token, response.data.expires_in + Date.now());     
                        context.commit('setAuth')  
                        resolve(response);
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Anmeldedaten nicht korrekt', action:'login'})
                        console.log('error')
                        reject(error);
                });
            })
        },        
        setAuthenticatedUser: function(context) {
            return new Promise(function(resolve, reject) {
                axios.get('api/user')
                    .then((response) => {
                                  
                    context.commit('setAuthenticatedUser',response.data)        
                    resolve(response)
                })
                    .catch((error) => {                        
                        reject(error)
                });
            })
           
        },
        setFirmen: function(context) {
            return new Promise(function(resolve, reject) {
            axios.get('api/firmen')
                .then((response)=>{ 
                    context.commit('setFirmen', response.data)                                
                    resolve(response);
                })
                .catch((error)=>{
                    console.log(error);
                    reject(error)
                });
            })
        },
        setMarken: function(context) {
            return new Promise(function(resolve, reject) {
            axios.get('api/marken')
                .then((response) => {      
                    context.commit('setMarken', response.data)                                                 
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
            })
        },
        setAdressen: function(context) {
            return new Promise(function(resolve, reject) {
            axios.get('api/adressen')
                .then((response) => {      
                    context.commit('setAdressen', response.data)                                                 
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
            })
        },
        setTypes: function(context) {
            return new Promise(function(resolve, reject) {
            axios.get('api/types')
                .then((response) => { 
                    
                    context.commit('setTypes', response.data)   
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
            })
        },
        setWarengruppen: function(context) {
            
            return new Promise(function(resolve, reject) {
            axios.get('api/warengruppen')
                .then((response) => { 
                    
                    context.commit('setWarengruppen', response.data)   
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
            })
        },
        setCCClients: function(context) {
            
            return new Promise(function(resolve, reject) {
            axios.get('api/ccClients')
                .then((response) => {                     
                    context.commit('setCCClients', response.data)                      
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
            })
        },
        postFirma: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.post('api/firmen', payload)
                    .then((response) => {  
                        context.dispatch('setSuccess', {message:'Firma erfolgreich angelegt', action:'postFirma'})
                        resolve(response.data)
                        
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Firma konnte nicht angelegt werden', action:'postFirma'})
                        console.log(error);
                });
            })
            
        },
        putFirma: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.put('api/firmen/' + payload.id, payload)
                    .then((response) => {       
                        context.dispatch('setSuccess', {message:'Firma erfolgreich geändert', action:'putFirma'})
                        resolve(response.data)
                        
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Firma konnte nicht geändert werden', action:'putFirma'})
                        console.log(error);
                });
            })
            
        },
        postMarke: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.post('api/marken', payload)
                    .then((response) => {         
                        context.dispatch('setSuccess', {message:'Marke erfolgreich angelegt', action:'postMarke'})
                        resolve(response.data)
                        
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Marke konnte nicht angelegt werden', action:'postMarke'})
                        console.log(error);
                });
            })
            
        },
        putMarke: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.put('api/marken/' + payload.id, payload)
                    .then((response) => {  
                        context.dispatch('setSuccess', {message:'Marke erfolgreich geändert', action:'putMarke'})
                        resolve(response.data)  
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Marke konnte nicht geändert werden', action:'putMarke'})
                        console.log(error);
                });
            })
            
        },
        postAdresse: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.post('api/adressen', payload)
                    .then((response) => {      
                        context.dispatch('setSuccess', {message:'Adresse erfolgreich angelegt', action:'postAdresse'})
                        resolve(response.data)
                        
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Adresse konnte nicht angelegt werden', action:'postAdresse'})
                        console.log(error);
                });
            })
            
        },
        putAdresse: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.put('api/adressen/' + payload.id, payload)
                    .then((response) => {  
                        context.dispatch('setSuccess', {message:'Adresse erfolgreich geändert', action:'putAdresse'})
                        resolve(response.data)  
                })
                    .catch((error) => {
                        context.dispatch('setError', {message:'Adresse konnte nicht geändert werden', action:'putAdresse'})
                        console.log(error);
                });
            })
            
        },
        
        postLogo: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.post('api/logos', payload, {headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => {
                    context.dispatch('setSuccess', {message:'Logo erfolgreich angelegt', action:'postLogo'})
                    resolve(response.data)
                })
                .catch((error)=> {
                    context.dispatch('setError', {message:'Logo konnte nicht angelegt werden', action:'postLogo'})
                    console.log(error) // catch your error
                });
            })
        },
        postApiMarken: function(context, payload) {
            return new Promise(function(resolve, reject) {
                axios.post('api/api/marken', payload)
                    .then((response) => {     
                        context.dispatch('setSuccess', {message:'API Konfiguration akzeptiert', action:'postApiMarken'})
                        resolve(response.data)
                    })
                    .catch((error) => {
                        context.dispatch('setError', {message:'API Konfiguration fehlgeschlagen', action:'postApiMarken'})
                        console.log(error);                        
                });
            })
        },
        getClientTokens: function(context) {
            return new Promise(function(resolve, reject) {
                axios.get('api/tokens')
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        deleteClientTokens: function(context,payload) {            
            return new Promise(function(resolve, reject) {
                axios.delete('api/tokens/' + payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        getAPIClients: function(context) {            
            return new Promise(function(resolve, reject) {
                axios.get('api/clients')
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        destroyAPIClients: function(context, payload) {               
            return new Promise(function(resolve, reject) {
                axios.delete('api/clients/' + payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);   
                        reject(error)
                });
            }) 
        },
        putAPIClients: function(context, payload) {            
            return new Promise(function(resolve, reject) {
                axios.put('api/clients/' + payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        postAPIClients: function(context, payload) {            
            return new Promise(function(resolve, reject) {
                axios.post('api/clients', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        getPersonalTokens: function(context) {            
            return new Promise(function(resolve, reject) {
                axios.get('api/personal-access-tokens')
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        postPersonalTokens: function(context,payload) {            
            return new Promise(function(resolve, reject) {
                axios.post('api/personal-access-tokens', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        destroyPersonalTokens: function(context, payload) {            
            return new Promise(function(resolve, reject) {
                axios.delete('api/personal-access-tokens/' + payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);   
                        reject(error)
                });
            }) 
        },
        
        getScopes:function(context) {            
            return new Promise(function(resolve, reject) {
                axios.get('api/scopes')
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);    
                });
            }) 
        },
        postCSV: function(context,payload) {            
            return new Promise(function(resolve, reject) {
                axios.post('api/importCSV', payload)
                    .then(response => {
                        context.dispatch('setSuccess', {message:'CSV Import erfolgreich abgeschlossen', action:'postCSV'})
                        resolve(response)
                    })
                    .catch((error) => {
                        context.dispatch('setError', {message:'CSV Import fehlgeschlagen', action:'postCSV'})
                        console.log(error);    
                });
            }) 
        },
    },
    getters: {
        apimarken: function(state) {
            return state.apimarken
        },
        apisuccess: function(state) {
            return state.apisuccess
        },
        apierror: function(state) {
            return state.apierror
        },
        messagebar: function(state) {
            return state.messagebar
        },
        emailRE: function(state) {
            return state.emailRE;
        },
        domainRE: function(state) {
            return state.domainRE;
        },
        telRE: function(state) {
            return state.telRE;
        },
        
        board: function(state) {
            return state.board;
        },
        authUser: function(state){            
            return state.authUser;                      
        },
        isAuth: function(state){
            return state.isAuth;
        },
        search:function(state){
            return state.search;
        },
        firmen: function(state) {
            return state.firmen;
        },
        firma: function(state) {
            return state.firma;
        },
        marken: function(state) {
            return state.marken;
        },
        marke: function(state) {
            return state.marke;
        },
        adressen: function(state) {
            return state.adressen;
        },
        adresse: function(state) {
            return state.adresse;
        },
        types: function(state) {
            return state.types
        },
        warengruppen: function(state) {
            return state.warengruppen
        },
        menuItems: function(state) {
            if(state.isAuth) {
                return state.authMenuItems
            } else {
                return state.menuItems
            }
        },
        loading: function(state) {
            return state.loading
        },
        ccClients: function(state) {
            return state.ccClients
        },
        preFilteredFirmen: function(state){
            return state.preFilteredFirmen;
        },
        preFilteredMarken: function(state){
            return state.preFilteredMarken;
        },
        showFilterDialog: function(state) {
            return state.showFilterDialog
        },
        
    },
    plugins: [vuexLocal.plugin]
    
    
})






// WEBPACK FOOTER //
// ./src/store/index.js